import { IonImg } from '@ionic/react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React from 'react';
import { IndianCasinoGameResultDTO } from '../../../../../models/IndianCasinoState';

type PropType = {
  resultsList: IndianCasinoGameResultDTO[];
};

const Lucky7ResultsTable: React.FC<PropType> = (props) => {
  const { resultsList } = props;

  return (
    <Table className="results-list-table">
      <TableHead className="tbl-header-section">
        <TableRow className="header-row">
          <TableCell className="header-cell">Match Id</TableCell>
          <TableCell className="header-cell" align="center">
            Result
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {resultsList.map((item, idx) => (
          <TableRow key={'result-' + idx} className="result-row">
            <TableCell key={'result-' + idx + '-mid'} className="match-id-cell">
              {item.mid.includes('.') ? item.mid.split('.')[1] : item.mid}
            </TableCell>
            <TableCell
              align="center"
              key={'result-' + idx + '-card-span'}
              className="result-card-cell"
            >
              <IonImg
                key={'result-' + idx + '-card'}
                className="oc-card"
                src={require(`../../../../../assets/images/casino/cards/${item.result}.png`)}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default Lucky7ResultsTable;
